<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">小テストマスタ登録</h1>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <caption>小テストマスタ</caption>
          <tr>
            <th class="v-middle"><span>小診断名</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.roughDiag.$model.title" @input="$v.roughDiag.$touch()" />
                <ValidationErrorMessage v-show="$v.roughDiag.title.$error && !$v.roughDiag.title.required" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>説明</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextArea v-model="$v.roughDiag.$model.description" @input="$v.roughDiag.$touch()" class="l-formGroup__textArea" />
                <ValidationErrorMessage v-show="$v.roughDiag.description.$error && !$v.roughDiag.description.required" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>開始日</span></th>
            <td class="v-middle">
              <div class="l-inputDate" style="padding-left: 20px;">
                <DatePicker v-model="$v.roughDiag.$model.fromDt" :value="this.roughDiag.fromDt"></DatePicker>
                <ValidationErrorMessage v-show="$v.roughDiag.fromDt.$error && !$v.roughDiag.fromDt.required" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>終了日</span></th>
            <td class="v-middle">
              <div class="l-inputDate" style="padding-left: 20px;">
                <DatePicker v-model="$v.roughDiag.$model.toDt" :value="this.roughDiag.toDt"></DatePicker>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>対応の表示条件</span></th>
            <td class="v-middle">
              <div class="l-inputDate" style="padding-left: 20px;">
                <RadioButton v-model="$v.roughDiag.$model.taiouDispType" :value="this.roughDiag.taiouDispType" :options="taiouDispTypes"  />
              </div>
            </td>
          </tr>

        </table>
        <table class="table-base audit-table table-select mt-30" style="width: 100%;">
          <caption class="rough-diag-item-input-title">小テスト項目</caption>
          <draggable :list="roughDiagItems">
            <div class="diag-item-div" v-for="(roughDiagItem, index) in roughDiagItems" :key="roughDiagItem.sortOrder">
            <colgroup>
              <col style="width: 20%;">
              <col style="width: 70%;">
              <col>
            </colgroup>
            <tr>
              <td>チェック項目</td>
              <td>
                <div class="l-inputAccount">
                  <TextArea v-model="$v.roughDiagItems.$model[index].checkItem" @input="$v.roughDiagItems.$touch()" class="l-formGroup__textArea" />
                  <ValidationErrorMessage v-show="$v.roughDiagItems.$each[index].checkItem.$error && !$v.roughDiagItems.$each[index].checkItem.required" validation="required" />
                </div>
              </td>
              <td rowspan="2" style="vertical-align: middle;">
                <div class="btn-basic is-small is-inlne" @click="deleteItem(index)"><a>この項目を削除</a></div>
              </td>
            </tr>
            <tr>
              <td>対応</td>
              <td>
                <div class="l-inputAccount">
                  <TextArea v-model="$v.roughDiagItems.$model[index].remediation" @input="$v.roughDiagItems.$touch()" class="l-formGroup__textArea" />
                  <ValidationErrorMessage v-show="$v.roughDiagItems.$each[index].remediation.$error && !$v.roughDiagItems.$each[index].remediation.required" validation="required" />

                  添付資料１ <TextBox v-model="$v.roughDiagItems.$model[index].guideCode1" placeholder="ガイドコードを入力してください" style="width:250px;"/><BR/>
                  添付資料２ <TextBox v-model="$v.roughDiagItems.$model[index].guideCode2" placeholder="ガイドコードを入力してください" style="width:250px;"/><BR/>
                  添付資料３ <TextBox v-model="$v.roughDiagItems.$model[index].guideCode3" placeholder="ガイドコードを入力してください" style="width:250px;"/>

                  </div>
              </td>
            </tr>
            </div>
          </draggable>
          <div class="btn-basic is-small is-inlne" style="margin: 20px 20px 20px 20px;" @click="addItem()"><a>項目を追加</a></div>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()" :disabled="isProcessing"><a>登録</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import DatePicker from '@/components/parts/form/DatePicker.vue';
import { required } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable'
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import RadioButton from '../../../parts/form/RadioButton.vue';
import constant from '@/const';
export default {
  components: {
    Loading,
    TextBox,
    TextArea,
    DatePicker,
    draggable,
    ValidationErrorMessage,
    RadioButton
},
  data() {
    return {
      isProcessing: false,
      roughDiag: {
        title: '',
        description: '',
        fromDt: null,
        toDt: null,
      },
      roughDiagItems: [
        {
          sortOrder: 1,
          checkItem: '',
          remediation: ''
        }
      ],
      options: {
        animation: 200
      },
      taiouDispTypes: constant.ROUGH_DIAG_TAIOU_DISP_TYPE
    }
  },
  validations: {
    roughDiag: {
      title: { required },
      description: { required },
      fromDt: { required },
      toDt: { },
    },
    roughDiagItems: {
      $each: {
        checkItem: { required },
        remediation: { required },
      }
    }
  },
  computed: {
    roughDiagId() {
      return this.$store.getters['master/getRoughDiagId'];
    },
  },
  created: function() {
    if (this.$route.name === 'rough-diag-master-edit') {
      this.getRoughDiag(this.roughDiagId);
    }
  },
  methods: {
    async getRoughDiag(roughDiagId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/roughDiag/getRoughDiag', {
        roughDiagId: roughDiagId,
      });
      if (res) {
        this.roughDiag = res.data.roughDiag;
        this.roughDiagItems = res.data.roughDiagItems;
      }
      this.isProcessing = false;
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/roughDiag/store', {
          roughDiag: this.roughDiag,
          roughDiagItems: this.roughDiagItems,
        });
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '登録が完了しました');
          this.$store.dispatch('master/setRoughDiagId', null);
          this.$router.push({ name: 'rough-diag-master-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    addItem() {
      let sortOrder = this.roughDiagItems.map(function (i) {
        return i.sortOrder;
      });
      let maxOrder = Math.max.apply(null, sortOrder);
      this.roughDiagItems.push({
        sortOrder: maxOrder + 1,
        checkItem: '',
        remediation: '',
      });
    },
    deleteItem(index) {
      if (this.roughDiagItems.length === 1) {
        this.$toast.error('1つ以上診断項目を入力してください');
        return;
      }
      this.roughDiagItems.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.l-form-table.diag-item-table tr {
  background-color: transparent;
}

.diag-item-div:nth-of-type(2n+1) {
  background-color: #f9f9f9;
}

.diag-item-div input[type="text"] {
  display: inline-block;
  -webkit-appearance: none;
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  width: 100%;
  max-width: 680px;
  padding: 5px 10px;
  font-size: 1.4rem;
  font-family: "Noto Sans JP","Helvetica Neue",Arial,sans-serif;
  width: 500px;
}

.rough-diag-item-input-title {
  margin: 20px 0 10px;
  padding-bottom: 10px;
  font-size: 1.8rem;
  font-weight: 700;
  text-align: left;
}

</style>
